import { Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

type Props = {
  color?: string;
  message?: string;
};

// TODO: use internationalization
const ErrorTypography = ({ color: colorProps, message: messageProps }: Props): JSX.Element => {
  const { t } = useTranslation();
  const color = colorProps ?? '#f44336';
  const message = messageProps ?? 'An unexpected Error has occurred';
  return <Typography color={color}><Trans>{message}</Trans></Typography>;
};

export default ErrorTypography;
